<template>
  <a-input-number
    v-bind="$attrs"
    :placeholder="placeholder"
    :class="[`c-input-number`, { 'text-center': isTextCenter }]"
    :controls="false"
    @keydown="handleKeyDown"
  >
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="$slots.suffix" #suffix>
      <slot name="suffix" />
    </template>
  </a-input-number>
</template>

<script>
import INumber from '@/components/common/Number.vue'

export default {
  name: 'InputNumber',
  components: { INumber },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    isDecimalNumber: {
      type: Boolean,
      default: false
    },
    isTextCenter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    validKey({ value, key, code, ctrlKey }) {
      const regexISDecimalNumber = /^[0-9]+$/
      const validKey = ['Backspace', 'Delete']
      const validCtrlKey = ['KeyV', 'KeyX', 'KeyC', 'KeyA']

      if (validKey.includes(code)) return true
      if (ctrlKey && validCtrlKey.includes(code)) return true
      if (!value && key === '-') return true
      if (this.isDecimalNumber && !value.includes('.')) {
        if (regexISDecimalNumber.test(key) || key === '.') return true
      }
      return regexISDecimalNumber.test(key)
    },
    handleKeyDown(evt) {
      const {
        target: { value }
      } = evt
      const { key, code, ctrlKey } = evt

      if (!this.validKey({ value, code, key, ctrlKey })) {
        evt.preventDefault()
      }
    }
  }
}
</script>

<script setup></script>
<style lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
.c-input-number.ant-input-number {
  width: 100%;
}
.text-center {
  .ant-input-number-input {
    text-align: center !important;
  }
}
</style>
